export var CoverageErrorType;
(function(CoverageErrorType) {
    CoverageErrorType[CoverageErrorType["KO"] = 0] = "KO";
    CoverageErrorType[CoverageErrorType["FWA"] = 1] = "FWA";
    CoverageErrorType[CoverageErrorType["R2_LOGGED"] = 2] = "R2_LOGGED";
    CoverageErrorType[CoverageErrorType["ERROR"] = 3] = "ERROR";
})(CoverageErrorType || (CoverageErrorType = {}));
